import { Client } from '@heroiclabs/nakama-js'
import { WebSocketAdapterPb } from '@heroiclabs/nakama-js-protobuf'
import { APP_NAME, APP_VERSION} from "../VERSION"

export default class NakamaConnector {
  constructor(nakamaConfig, protocolAdapterClass) {
    this._config = nakamaConfig
    this._match = null
    this._readyConfirmed = false
    this._protocolAdapterClass = protocolAdapterClass
    this._adapter = null
  }

  async _init(rtsConfig, firebaseIdToken) {
    const serverKey =
      (rtsConfig && rtsConfig.server_key) || this._config.serverKey
    const serverHost =
      (rtsConfig && rtsConfig.server_host) || this._config.serverHost
    const serverPort =
      (rtsConfig && rtsConfig.server_port) || this._config.serverPort
    const serverUseSSL =
      (rtsConfig && rtsConfig.server_ssl) || this._config.serverSSL

    console.log(
      'nakama server',
      serverKey,
      serverHost,
      serverPort,
      serverUseSSL
    )

    this._client = new Client(
      serverKey,
      serverHost,
      '' + serverPort,
      serverUseSSL
    )

    const vars = firebaseIdToken ? { ftoken: firebaseIdToken } : {}

    this._session = await this._client.authenticateCustom('', true, '', vars)

    this._socket = this._client.createSocket(
      serverUseSSL,
      this._config.trace,
      new WebSocketAdapterPb()
    )

    this._adapter = new this._protocolAdapterClass(this._socket)

    this._socket.onmatchdata = (matchData) => {
      this.onMatchData(this._adapter.onMatchData(matchData))
    }

    return this._socket.connect(this._session)
  }

  async join(match, firebaseIdToken) {
    this._match = match

    await this._init(match.rts, firebaseIdToken)
    // passing meta to play tournament
    return await this._socket.joinMatch(match.rts_match_id, "", { client_version: APP_VERSION, client_name: APP_NAME })
  }

  async joinAnonymously(params, firebaseIdToken) {
    await this._init(null, firebaseIdToken)

    const result = await this._client.rpc(
      this._session,
      `checkers_create_match_as_guest`,
      params
    )

    this._match = { rts_match_id: result.payload.match_id }
    // console.error('joinAnonymously', params, result);
    return await this._socket.joinMatch(this._match.rts_match_id)

    // return result;
  }

  disconnect() {
    if (this._socket) {
      this._socket.disconnect()
    }
  }

  confirmReady() {
    if (!this._readyConfirmed && this._adapter) {
      this._adapter.confirmReady(this._match.rts_match_id)
      this._readyConfirmed = true
    }
  }

  sendMove(moveId) {
    if (this._adapter) {
      this._adapter.sendMove(this._match.rts_match_id, moveId)
    }
  }

  proposeDraw() {
    if (this._adapter) {
      this._adapter.proposeDraw(this._match.rts_match_id)
    }
  }

  acceptDrawProposal() {
    if (this._adapter) {
      this._adapter.acceptDrawProposal(this._match.rts_match_id)
    }
  }

  rejectDrawProposal() {
    if (this._adapter) {
      this._adapter.rejectDrawProposal(this._match.rts_match_id)
    }
  }

  surrender() {
    if (this._adapter) {
      this._adapter.surrender(this._match.rts_match_id)
    }
  }
  // eslint-disable-next-line
  async onMatchData(matchData) { }
}
